export default {
    driverPerformanceConfig_functions: "Funciones",
    driverPerformanceConfig_dashboard: "Consola",   
}